import {FC} from 'react'
import {createPortal} from 'react-dom'

export const Portal: FC<{container?: HTMLElement | null}> = ({children, container}) => {
    if (!container) return null
    return createPortal(children, container)
}
